export default __webpack_public_path__ + "static/media/lucky_light2.4feaecc7.png";